import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { AppStoreButtons } from "@/components/AppStoreButtons";
import { Contours } from "@/components/Contours";
import { LogoMark } from "@/components/Logo";

export const FinalCTA = () => {
  const { t } = useLanguage();
  const s = t.finalCta;

  return (
    <section id="download" className="relative scroll-mt-24 py-12 md:py-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-[2.5rem] border border-[var(--line)] bg-[var(--forest)] px-6 py-20 text-center md:px-16 md:py-28"
        >
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_120%,rgba(127,121,57,0.45),transparent_60%)]" aria-hidden="true" />
          <Contours rings={12} step={60} seed={5} cx={700} cy={520} opacity={0.2} stroke="#dfe7d5" />
          <div className="relative mx-auto max-w-2xl">
            <LogoMark className="mx-auto h-16 w-16 rounded-2xl shadow-2xl ring-1 ring-white/10" />
            <p className="eyebrow mt-8 text-[#dfe7d5]/80">{s.eyebrow}</p>
            <h2 className="font-display mt-4 text-4xl leading-[1.02] text-white sm:text-5xl lg:text-6xl">{s.title}</h2>
            <p className="mx-auto mt-6 max-w-xl text-base text-[#dfe7d5]/85 md:text-lg">{s.subtitle}</p>
            <div className="mt-10 flex justify-center">
              <AppStoreButtons idPrefix="cta" className="justify-center" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
